"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postLomsEvent = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const icf_platform_client_1 = require("@atg/icf-platform-client");
const axios_1 = __importStar(require("axios"));
const http_status_codes_1 = require("http-status-codes");
/**
 *
 * @param {LomsEvent} event - The LOMS event being published
 * @param {string} eventKey - The message key, not required but effectively used as a primary key for the event
 * @returns The status code of the response and error details if present
 */
const postLomsEvent = async (event, eventKey) => {
    try {
        const response = await axios_1.default.post("/api/loms", { event, eventKey });
        return { status: response.status };
    }
    catch (error) {
        if ((0, axios_1.isAxiosError)(error)) {
            return {
                status: error.response?.status ?? http_status_codes_1.StatusCodes.BAD_REQUEST,
                error: error.message,
            };
        }
        return {
            status: http_status_codes_1.StatusCodes.INTERNAL_SERVER_ERROR,
            error: (0, icf_platform_client_1.errorMessageFrom)(error),
        };
    }
};
exports.postLomsEvent = postLomsEvent;
